import { useEffect, useState } from "react";
import { Table, Button, Modal, Form, Select, Input, DatePicker } from "antd";
import BitwiseEditor from "../componente/BitwiseEditor";
import bitLabels from "../componente/bitLabels.json"
import type { IDocumento, IGrupoDocumento, ITipo } from "../../../../components/Interfaces";

export default function DocumentoCrud() {
  const [docs, setDocs] = useState<IDocumento[]>([]);
  const [tipos, setTipos] = useState<ITipo[]>([]);
  const [grupos, setGrupos] = useState<IGrupoDocumento[]>([]);
  const [open, setOpen] = useState(false);

  const [form] = Form.useForm();

  const load = async () => {
    setDocs(await fetch("/api/documentos").then(r => r.json()));
    setTipos(await fetch("/api/tipos").then(r => r.json()));
    setGrupos(await fetch("/api/grupos").then(r => r.json()));
  };

  useEffect(() => { load(); }, []);

  const onSave = async () => {
    const values = form.getFieldsValue();
    await fetch("/api/documentos", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(values),
    });
    setOpen(false);
    load();
  };

  return (
    <>
      <Button type="primary" onClick={() => setOpen(true)}>Novo Documento</Button>

      <Table dataSource={docs} rowKey="id">
        <Table.Column title="ID" dataIndex="id" />
        <Table.Column title="Nome" dataIndex="nomeDocumento" />
        <Table.Column title="Bitwise" dataIndex="bitwise" />
      </Table>

      <Modal
        title="Cadastrar Documento"
        open={open}
        onCancel={() => setOpen(false)}
        onOk={onSave}
        width={900}
      >
        <Form form={form} layout="vertical">

          <Form.Item name="idTipoDocumento" label="Tipo de Documento" rules={[{ required: true }]}>
            <Select
              options={tipos.map(t => ({ value: t.id, label: t.nome }))}
            />
          </Form.Item>

          <Form.Item name="idGrupo" label="Grupo" rules={[{ required: true }]}>
            <Select
              options={grupos.map(g => ({ value: g.id, label: g.nome }))}
            />
          </Form.Item>

          <Form.Item name="nomeDocumento" label="Nome" rules={[{ required: true }]}>
            <Input />
          </Form.Item>

          <Form.Item name="inicioVigencia" label="Início de Vigência" rules={[{ required: true }]}>
            <DatePicker />
          </Form.Item>

          <Form.Item name="bitwise" label="Bitwise">
            <BitwiseEditor
              labels={bitLabels}
              onChange={(val: bigint) => form.setFieldValue("bitwise", val.toString())}
            />
          </Form.Item>

        </Form>
      </Modal>
    </>
  );
}
